import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { loginGovPl, logout } from '../../store/actions/app.actions';
import { SessionService, TokenData } from '../../services/ssession.service';
import { CommonModule } from '@angular/common';
import { ContentComponent } from '../../components/content/content.component';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertComponent } from '../../common/alert/alert.component';

@Component({
  selector: 'app-login-gov-page',
  standalone: true,
  imports: [
    CommonModule,
    ContentComponent,
    SpinnerComponent,
    AlertComponent
  ],
  templateUrl: './login-gov-page.component.html'
})
export class LoginGovPageComponent implements OnInit {

  public samlart: string | undefined = this.route.snapshot.queryParams['samlart'];

  public message = 'Poczekaj trwa ładowanie danych...';

  public error: HttpErrorResponse | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store$: Store
  ) {
  }

  private onLoginSuccess = (data: TokenData | null) => {
    this.router.navigate(['./strona-glowna']).then(() => {
      if (SessionService.IsCompletedUserData()) {
        this.router.navigate([SessionService.GetGoBackUrl()]).then(v => {
          SessionService.RemoveGoBackUrl();
        });
      } else {
        this.router.navigate(['./moje-dane']);
      }
    });
  };

  private onLoginFailure = (v: HttpErrorResponse) => {
    this.store$.dispatch(logout({
      successFnc: () => {
      }
    }));
    this.samlart = undefined;
    this.error = v;
  };

  public ngOnInit(): void {
    if (this.samlart) {
      this.store$.dispatch(loginGovPl({
        samlart: this.samlart || '',
        successFnc: this.onLoginSuccess,
        failureFnc: this.onLoginFailure
      }));
    } else {
      setTimeout(() => {
        this.router.navigate(['./strona-glowna']);
      }, 300)
    }
  }
}
